// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dashboard-page .m-portlet__body > .details-block:not(:last-child) {\n  border-bottom: 1px solid #ebedf2;\n}\n", ""]);
// Exports
module.exports = exports;
